export default "__VITE_ASSET__DxNxq$xY__"